/** The Dira mark: a ring with the accent compass needle (the artboards' logo). */
export function Mark({ size = 26 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <circle
        cx="12"
        cy="12"
        r="10.5"
        fill="none"
        className="stroke-ink"
        strokeWidth="1.5"
      />
      <path d="M12 3.5 L14.2 12 L12 20.5 L9.8 12 Z" className="fill-accent" />
      <path d="M12 3.5 L14.2 12 L9.8 12 Z" className="fill-ink" />
      <circle cx="12" cy="12" r="1.3" className="fill-surface" />
    </svg>
  );
}
